import React from 'react';

import {Button, Text} from '@albert-io/atomic';
import {EmptyState, EmptyIllustration} from 'client/TeacherDashboard/components/EmptyState';
import {NoSearchResults} from 'client/TeacherDashboard/components/NoSearchResults';
import {history} from 'client/history';

import type {StatusSegment} from './constants';
import {getCreateAssignmentPath, STATUS_SEGMENTS} from './constants';

const CreateAssignmentButton = ({classroomId}: {classroomId?: string}) => (
  <Button
    onClick={() => history.pushState(null, getCreateAssignmentPath(classroomId))}
    roundness='pill'
  >
    Create New Assignment
  </Button>
);

/** Whole scope (all classes or one class) has no assignments — renders alone, below the header. */
export const AssignmentsOnboardingEmptyState = ({classroomId}: {classroomId?: string}) => (
  <EmptyState
    action={<CreateAssignmentButton classroomId={classroomId} />}
    illustration={<EmptyIllustration icon='file-lines' />}
  >
    <div className='flex flex-col gap-x1'>
      <Text as='div' bold size='l'>
        No Assignments Yet!
      </Text>
      <Text as='div' className='max-w-[440px]' color='secondary'>
        Create, view, organize, and manage assignments all in one place.
      </Text>
    </div>
  </EmptyState>
);

/** Scope has assignments, but the active status tab has none — renders under the controls. */
export const AssignmentStatusEmptyState = ({
  segment,
  classroomId
}: {
  segment: StatusSegment;
  classroomId?: string;
}) => {
  const label = STATUS_SEGMENTS.find((s) => s.value === segment)?.label ?? '';
  return (
    <EmptyState
      action={<CreateAssignmentButton classroomId={classroomId} />}
      illustration={<EmptyIllustration icon='file-lines' />}
    >
      <Text as='div' size='l'>
        No {label} Assignments
      </Text>
    </EmptyState>
  );
};

/** The active filters/search matched nothing. No reset action — the user adjusts filters/search. */
export const AssignmentsFilteredEmptyState = () => <NoSearchResults />;
